import { postPublicEvent, PUBLIC_WEBSITE_SLUG } from "@/lib/publicApi";

type SiteAnalyticsEventType = "pageview" | "heartbeat";

type SiteAnalyticsEventPayload = {
  event_type: SiteAnalyticsEventType;
  path?: string;
  referrer?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  screen_width?: number | null;
  session_id?: string;
};

const SESSION_STORAGE_KEY = "site_analytics_session_id";

function getSessionId(): string {
  try {
    const existing = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (existing) return existing;
    const id = Math.random().toString(16).slice(2, 10) + Math.random().toString(16).slice(2, 10);
    sessionStorage.setItem(SESSION_STORAGE_KEY, id);
    return id;
  } catch {
    return "";
  }
}

function getUtmParams() {
  const sp = new URLSearchParams(window.location.search);
  return {
    utm_source: sp.get("utm_source") || "",
    utm_medium: sp.get("utm_medium") || "",
    utm_campaign: sp.get("utm_campaign") || "",
  };
}

function buildPayload(eventType: SiteAnalyticsEventType): SiteAnalyticsEventPayload {
  return {
    event_type: eventType,
    path: window.location.pathname + window.location.search,
    referrer: document.referrer || "",
    ...getUtmParams(),
    screen_width: typeof window !== "undefined" ? window.innerWidth : null,
    session_id: getSessionId(),
  };
}

function postEvent(payload: SiteAnalyticsEventPayload) {
  postPublicEvent(`/${PUBLIC_WEBSITE_SLUG}/site-analytics/event/`, payload);
}

export function trackPageview() {
  postEvent(buildPayload("pageview"));
}
